import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { useIntl } from "react-intl";

const TrashButton = ({ disabled, titleId, onClick }) => {
  const intl = useIntl();
  return (
    <Button
      size="sm"
      variant="link"
      className={disabled ? "text-secondary" : "text-danger"}
      disabled={disabled}
      title={intl.formatMessage({ id: titleId ?? "app.common.action.delete" })}
      aria-label={intl.formatMessage({ id: titleId ?? "app.common.action.delete" })}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faTrash} />
    </Button>
  );
};

export default TrashButton;
